<template>
  <div class="profile-user">
    <div class="row">
      <q-linear-progress indeterminate v-if="loading"></q-linear-progress>
      <!-- start form part -->
      <div class="the-form">
        <div class="form-body">
          <!-- form -->
          <q-form @submit.prevent="updataProfile">
            <div class="row">
              <div class="col-xs-12 col-sm-6 forms-info">
                <!-- form inputs -->
                <label>Full Name</label>
                <q-input
                  bg-color="positive"
                  reactive-rules
                  label-color="secondary"
                  filled
                  v-model="formData.name"
                  label="Enter Full Name"
                />
                <label>Email</label>
                <q-input
                  bg-color="positive"
                  reactive-rules
                  label-color="secondary"
                  filled
                  v-model="formData.email"
                  label="Enter Email"
                />
                <label>Gender</label>

                <q-select
                  filled
                  label="Select gender"
                  :options="genderOptions"
                  v-model="gender"
                  option-label="label"
                  option-value="value"
                ></q-select>
                <label>Type of User</label>
                <q-select 
                  option-label="label"
                  option-value="value"
                  label-color="secondary"
                  filled
                  v-model="type" 
                  :options="userTypeOptions" 
                  label="Select type of user"
                />

                <label>Organizations</label>

                <q-select
                  filled
                  label="Select organizations"
                  :options="subAdminOptions"
                  v-model="admin_id"
                  option-label="name"
                  option-value="id"
                ></q-select>
                <label>Schools</label>
                <q-select
                  filled
                  label="Select school"
                  :options="schools"
                  v-model="school_id"
                  option-label="school"
                  option-value="id"
                ></q-select>
                <!-- male 0, female 1-->

                <!--                                <q-input bg-color="positive" reactive-rules label-color="secondary" filled-->
                <!--                                         v-model="formData.gender" label="Enter Gender"/>-->
                <!-- form inputs -->
              </div>
              <div class="col-xs-12 col-sm-6">
                <div class="upload-image">
                  <label>Upload image</label>
                  <div style="position: relative" class="upload-holder">
                    <img
                      class="img-perview"
                      v-if="imagePreviewURL"
                      :src="imagePreviewURL"
                      alt=""
                    />
                    <q-file
                      @input="onFileChange"
                      accept="image/"
                      bg-color="positive"
                      color="teal"
                      filled
                      v-model="formData.image"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25.1"
                        height="25.1"
                        viewBox="0 0 25.1 25.1"
                      >
                        <g
                          id="Icon_feather-upload"
                          data-name="Icon feather-upload"
                          transform="translate(-3.5 -3.5)"
                        >
                          <path
                            id="Path_13361"
                            data-name="Path 13361"
                            d="M27.6,22.5v5.133A2.567,2.567,0,0,1,25.033,30.2H7.067A2.567,2.567,0,0,1,4.5,27.633V22.5"
                            transform="translate(0 -2.6)"
                            fill="none"
                            stroke="#7c7c7c"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                          />
                          <path
                            id="Path_13362"
                            data-name="Path 13362"
                            d="M23.333,10.917,16.917,4.5,10.5,10.917"
                            transform="translate(-0.867 0)"
                            fill="none"
                            stroke="#7c7c7c"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                          />
                          <path
                            id="Path_13363"
                            data-name="Path 13363"
                            d="M18,4.5V19.9"
                            transform="translate(-1.95 0)"
                            fill="none"
                            stroke="#7c7c7c"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                          />
                        </g>
                      </svg>
                    </q-file>
                  </div>
                  <br />
                </div>
                <div class="pl-20px">
                  <label>Robot Name</label>
                  <q-input
                    bg-color="positive"
                    reactive-rules
                    label-color="secondary"
                    filled
                    maxlength="12"
                    v-model="formData.robot_name"
                    label="Enter Robot Name"
                  />

                  <label>Robot Color</label>
                  <q-input
                    :style="`background-color:${formData.robot_color}`"
                    filled
                    v-model="formData.robot_color"
                    reactive-rules
                    label-color="secondary"
                    no-header-tabs
                    readonly
                    label="Select Robot Color"
                  >
                    <template v-slot:append>
                      <i class="fas fa-eye-dropper">
                        <q-popup-proxy
                          transition-show="scale"
                          transition-hide="scale"
                        >
                          <q-color v-model="formData.robot_color" />
                        </q-popup-proxy>
                      </i>
                    </template>
                  </q-input>
                </div>
              </div>
            </div>
            <div class="submit">
              <ButtonComponent>Save Changes</ButtonComponent>
              <!-- end send message  button -->
            </div>
          </q-form>
          <!-- end form -->
        </div>
      </div>
      <!-- end form part -->

      <!-- model error -->
      <q-dialog v-model="alert">
        <q-card>
          <q-card-section>
            <div class="text-h6">Alert</div>
          </q-card-section>

          <q-card-section class="q-pt-none">
            <div v-for="formError in formErrors" :key="formError.id">
              <p>{{ formError }}</p>
            </div>
            <div v-for="formDons in formDone" :key="formDons.id">
              <p>{{ formDons }}</p>
            </div>
          </q-card-section>

          <q-card-actions align="right">
            <q-btn flat label="OK" color="primary" v-close-popup />
          </q-card-actions>
        </q-card>
      </q-dialog>
      <!-- end model error -->
    </div>
  </div>
</template>

<script>
import ButtonComponent from "@/components/tools/ButtonComponent";

export default {
  data() {
    return {
      adminName: null,
      schoolName: null,
      subAdminOptions: [],
      schools: [],
      userTypeOptions: [{label: 'Student', value: 0}, {label: 'Coach', value: 2}],
      genderOptions: [
        {
          value: 0,
          label: "Male",
        },
        {
          value: 1,
          label: "Female",
        },
      ],
      gender: {
        value: this.$store.state.userData.gender,
        label: this.$store.state.userData.gender == 0 ? "Male" : "Female",
      },
      type: {
        value: this.$store.state.userData.type,
        label: this.$store.state.userData.type == 0 ? "Student" : "Coach",
      },
      admin_id: {
        id: this.$store.state.userData.admin_id,
        name: this.adminName ?? this.$store.state.userData.admin_id,
      },
      school_id: {
        id: this.$store.state.userData.school_id,
        school: this.schoolName ?? this.$store.state.userData.school_id,
      },
      formData: {
        image: null,
        name: this.$store.state.userData.name,
        email: this.$store.state.userData.email,
        type: this.$store.state.userData.type,
        robot_name: this.$store.state.userData.robot_name ?? "Robot-name",
        robot_color: this.$store.state.userData.robot_color ?? "#247735",
      },
      alert: false,
      loading: false,
      formDone: [],
      formErrors: [],
      imagePreviewURL: null,
    };
  },
  components: { ButtonComponent },
  watch: {
    ""() {
      this.subAdminOptions.map((admin) => {
        if (this.admin_id.id == admin.id) {
          this.admin_id.name = admin.name;
          this.adminName = admin.name;
        }
      });

      this.school_id.id = response.data.data.school_id;
      this.schools.map((school) => {
        if (this.school_id.id == school.id) {
          this.school_id.school = school.school;
          this.schoolName = school.school;
        }
      });
    },
  },
  created() {
    this.getSubAdmins();
    this.getSchools();

    this.$API.userProfile
      .getProfile()
      .then((response) => {
        this.$store.commit("getUserData", response.data.data);
        this.admin_id.id = response.data.data.admin_id;
        this.subAdminOptions.map((admin) => {
          if (this.admin_id.id == admin.id) {
            this.admin_id.name = admin.name;
            this.adminName = admin.name;
          }
        });

        this.school_id.id = response.data.data.school_id;
        this.schools.map((school) => {
          if (this.school_id.id == school.id) {
            this.school_id.school = school.school;
            this.schoolName = school.school;
          }
        });
      })
      .catch((err) => {
        // make log out if something is worng or token is expierd
        if (err.response.data.status === false) {
          this.logOut();
        }
      });
  },
  methods: {
    getSubAdmins() {
      this.$API.userProfile.getSubAdmins().then((response) => {
        this.subAdminOptions = response.data.data;
      });
    },
    getSchools() {
      this.$API.userProfile.getSchools().then((response) => {
        this.schools = response.data.data;
      });
    },
    updataProfile() {
      const formData = new FormData();
      if (this.formData.image) {
        formData.append("image", this.formData.image);
      }
      console.log(this.formData);
      formData.append("name", this.formData.name);
      formData.append("gender", this.gender.value);
      formData.append("email", this.formData.email);
      formData.append("robot_name", this.formData.robot_name);
      formData.append("robot_color", this.formData.robot_color);
      formData.append("admin_id", this.admin_id.id);
      formData.append("school_id", this.school_id.id);
      formData.append("type", this.type.value);
      this.formDone = [];
      this.formErrors = [];
      this.loading = true;
      this.$API.userProfile
        .updateProfile(formData)
        .then((response) => {
          this.formDone.push(response.data.message);
          this.loading = false;
          this.alert = true;
          this.$API.userProfile
            .getProfile()
            .then((response) => {
              this.$store.commit("getUserData", response.data.data);
            })
            .catch((err) => {
              // make log out if something is worng or token is expierd
              if (err.response.data.status === false) {
                this.logOut();
              }
            });
        })
        .catch((err) => {
          this.loading = false;
          this.formErrors.push(err.response.data.message);
          this.loading = false;
          this.alert = true;
        });
    },
    onFileChange() {
      let file = this.formData.image;
      if (file) {
        this.imagePreviewURL = URL.createObjectURL(file);
        URL.revokeObjectURL(file);
      } else {
        this.imagePreviewURL = null;
      }
    },
  },
};
</script>


<style scoped>
.pl-20px {
  padding-left: 20px;
}
.the-form {
  width: 100%;
}

.the-form .form-body form {
  padding: 0px;
}

.the-form .form-body form .upload-image {
  padding-left: 20px;
  position: relative !important;
}

.img-perview {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 2;
  border-right: 5px;
  padding: 5px;
}

.the-form .form-body form .upload-image svg {
  position: absolute;
  bottom: 25px;
  right: 25px;
  font-size: 50px;
  color: #cccc;
}

.the-form .form-body form .upload-image .upload-holder {
  background: #f4f5f8;
  height: 231px;
}

@media screen and (max-width: 600px) {
  .upload-image {
    padding-left: 0 !important;
  }
}

.submit {
  margin-top: 25px;
}
</style>
